import React, { useState, useCallback } from 'react';
import { Select } from 'antd';

import defaultStyles from './style.less';

const { Option } = Select;

function ComboAnswer({ href,
                       onChange,
                       answer,
                       disabled,
                       mutating,
                       styles = {
                         correctAnswer: defaultStyles.correctAnswer,
                         incorrectAnswer: defaultStyles.incorrectAnswer,
                         measurer: defaultStyles.measurer
                       }
                     }) {
  const [width, setWidth] = useState(120);
  const measureRef = useCallback(domNode => {
    if (domNode) {
      setWidth(domNode.clientWidth + 48);
    }
  }, []);

  const [index, ...options] = decodeURI(href.slice(1)).split('|').filter(s => !!s);

  const answerElement = answer && answer.answerElements && answer.answerElements.find(ae => ae.index == index);
  const answervalue = answerElement && answerElement.value;

  const optionsElems = options.map(o => <Option key={o.replace(/\*/g, '')}>{o.replace(/\*/g, '')}</Option>);

  const placeholder = 'Select an answer';
  let longestOption = options.reduce(function (a, b) { return a.length > b.length ? a : b; });

  longestOption = longestOption.length > placeholder.length ? longestOption : placeholder;

  const isCorrect = answervalue && options.some(o => o === `*${answervalue}*`);

  const selectClass = disabled ? (isCorrect ? styles.correctAnswer : styles.incorrectAnswer) : '';

  const onLocalChange = (e) => {
    onChange({ index, value: e, correct: options.some(o => o === `*${e}*`) });
  };

  return (
    <React.Fragment>
      <div ref={measureRef} className={styles.measurer}>{longestOption}</div>
      <Select
        className={selectClass}
        style={{minWidth: width}}
        disabled={disabled || mutating}
        onChange={onLocalChange}
        placeholder={placeholder}
        value={answervalue}
      >
        { optionsElems }
      </Select>
    </React.Fragment>
  );
}

export default ComboAnswer;
